import { SecureRoute } from '@okta/okta-react';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { Switch, useHistory, useRouteMatch } from 'react-router';
import { HeaderMenu } from 'components/atoms/menu';
import { Page } from 'components/molecules/page';
import { CompanyTasks, Overview } from 'components/organisms/home';
import { UserGreeting } from 'components/organisms/user-greeting';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';

export const HomePage: FC = () => {
  const {
    user: {
      company: { companyName },
    },
  } = useUser();

  const history = useHistory();
  const { path } = useRouteMatch();

  return (
    <Page $gray>
      <Page.Header
        sticky
        title={<UserGreeting />}
        tabs={
          <HeaderMenu
            defaultSelectedKeys={[RoutePaths.home]}
            selectedKeys={[path]}
            mode="horizontal"
            onClick={({ key }) => history.push(String(key))}
          >
            <HeaderMenu.Item key={RoutePaths.home}>
              {useTranslation('home.title')}
            </HeaderMenu.Item>
            <HeaderMenu.Item key={RoutePaths.companyTasks}>
              {useTranslation('menu.label.company_tasks', { companyName })}
            </HeaderMenu.Item>
          </HeaderMenu>
        }
      />
      <Page.Content>
        <Switch>
          <SecureRoute path="/" exact>
            <Helmet>
              <title>{useTranslation('home.title')} </title>
            </Helmet>
            <Overview />
          </SecureRoute>
          <SecureRoute path="/company-tasks" exact>
            <Helmet>
              <title>
                {useTranslation('menu.label.company_tasks', { companyName })}
              </title>
            </Helmet>
            <CompanyTasks />
          </SecureRoute>
        </Switch>
      </Page.Content>
    </Page>
  );
};
